<template>
  <div class="content-register">
    <b-card>
      <b-tabs>
        <b-tab title="Conteúdo">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="code" placeholder="Código" v-model="form.code" />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                    multiple
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtBr" placeholder="Nome PT-BR" v-model="form.namePtBr" />
                  <label for="name">Nome PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEnEu" placeholder="Nome EN-EU" v-model="form.nameEnEu" />
                  <label for="name">Nome EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsEs" placeholder="Nome ES-ES" v-model="form.nameEsEs" />
                  <label for="name">Nome ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsAr" placeholder="Nome ES-AR" v-model="form.nameEsAr" />
                  <label for="name">Nome ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtPt" placeholder="Nome PT-PT" v-model="form.namePtPt" />
                  <label for="namePtPt">Nome PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameZhCn" placeholder="Nome ZH-CN" v-model="form.nameZhCn" />
                  <label for="nameZhCn">Nome ZH-CN</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="order" placeholder="Ordem" v-model="form.order" />
                  <label for="name">Ordem</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="icon" placeholder="Icone" v-model="form.icon" />
                  <label for="name">Icone</label>
                </div>
              </b-col>
              <b-col md="12"><hr></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Tipo de evento (Gráfico)</label>
                  <b-form-group label="Tipo de evento (Gráfico)" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.chartEvent"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="chartEvent"
                    multiple
                    :reduce="option => option.id"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-created" placeholder="Data Criação" v-model="form.dt_create" disabled />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-created" placeholder="Email Criação" v-model="form.email_create" disabled />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-update" placeholder="Data Alteração" v-model="form.dt_update" disabled />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-update" placeholder="Email Alteração" v-model="form.email_update" disabled />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-delete" placeholder="Data Desativação" v-model="form.dt_delete" disabled />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-delete" placeholder="Email Desativação" v-model="form.email_delete" disabled />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">Ativo</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="isQuotes" name="isQuotes" checked="false" v-model="form.isQuotes">Cotação</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="isReport" name="isReport" checked="false" v-model="form.isReport">Relatório</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="displaySubmenu" name="displaySubmenu" checked="false" v-model="form.displaySubmenu">Mostrar submenu</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="displayInPublicArea" name="displayInPublicArea" checked="false" v-model="form.displayInPublicArea">Mostrar na área pública</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="enableInPublicArea" name="enableInPublicArea" checked="false" v-model="form.enableInPublicArea">Habilitar na área pública</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">Enviar</b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">Voltar</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Configuração">
          <div>
            <small>Configuração feita para mostrar a cor de fundo das noticias no calendário da plataforma safras</small>
          </div>
          <b-card v-if="displayContentConfigForm">
            <h2>{{isUpdateContentConfigForm ? 'Alteração da cor ' : 'Inserir nova cor '}}<span class="search-related-news">{{contentConfigForm.origin ? contentConfigForm.origin.name : ''}}</span></h2>
            <b-row>
              <b-col md="4">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                    <v-select id="origin-list" v-model="contentConfigForm.origin" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name" :options="origins">
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="2" class="mt-2">
                <div class="form-label-group">
                  <b-form-input placeholder="Selecione uma cor" v-model="contentConfigForm.color" type="color"/>
                  <label for="routeName">Cor</label>
                </div>
              </b-col>
            </b-row>
            <b-button variant="primary" class="mr-1" @click="onSubmitContentConfig">{{ isUpdateContentConfigForm ? 'Atualizar' : 'Adicionar'}}</b-button>
          </b-card>
          <hr v-if="displayContentConfigForm">
          <b-row>
            <b-col md="6">
              <b-button size="sm" @click="newColorOrigin" class="btn-sm btn-nav-link btn-nav-link-primary">
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">Novo</span>
              </b-button>
            </b-col>
            <b-col md="12" class="mt-1">
              <b-list-group v-if="form.color_origin">
                <b-list-group-item v-for="(item, index) in form.color_origin" :key="index" class="list-item-related-news" @click="updateContentconfigForm(item)">
                  <feather-icon icon="CircleIcon" class="mr-50" style="margin-bottom: 3px" /> <b>{{item.origin.name}} ({{item.origin.code}})</b> | {{item.color}} <span class="dot-12" :style="getDotStyle(item.color)"></span>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Rotas Plataforma-Wdma">
          <ContentRegisterRoutes
            :platformWdmaRoute="form.platformWdmaRoute"
            :countries="countries"
            @submit-route="updateRoute"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
  BTabs, BTab, BCard, BListGroup, BListGroupItem,
} from "bootstrap-vue";
import contentService from "@/providers/contentService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import ContentRegisterRoutes from './ContentRegisterRoutes.vue';
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      subjects: [],
      reportType: [],
      chartEvent: [],
      countries: [],
      displayContentConfigForm: false,
      isUpdateContentConfigForm: false,
      contentConfigForm: {
        origin: {},
        color: AppConstants.DEFAULT_CONTENT_CONFIG_COLOR
      },
      form: {
        _id: "",
        code: "",
        namePtBr: "",
        nameEnEu: "",
        nameEsEs: "",
        nameEsAr: "",
        namePtPt: "",
        nameZhCn: "",
        icon: "",
        order: "",
        origin: [],
        chartEvent: [],
        search_origin: [],
        search_subject: "",
        color_origin: [],
        platformWdmaRoute: [],
        active: true,
        isQuotes: false,
        isReport: false,
        displaySubmenu: false,
        displayInPublicArea: false,
        enableInPublicArea: false,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Conteúdo');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
    }
    this.loadData();
  },
  watch: {
    "form.namePtBr"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Conteúdo');
      }
    },
    "form.search_origin"(val) {
      if (val) {
        this.loadSubjects();
      } else {
        this.subjects = [];
        this.form.search_subject = null;
      }
    }
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    getDotStyle(color) {
      return `background-color: ${color}`;
    },
    onSubmitContentConfig() {
      const form = JSON.parse(JSON.stringify(this.contentConfigForm));
      const index = this.form.color_origin.findIndex(item => item.origin.id == form.origin.id);
      if (index < 0) {
        this.form.color_origin.push(form);
      } else {
        this.form.color_origin[index].color = form.color;
      }
      this.clearContentConfigForm();
      this.displayContentConfigForm = false;
      this.isUpdateContentConfigForm = false;
    },
    updateContentconfigForm(item) {
      this.clearContentConfigForm();
      this.contentConfigForm = item;
      this.displayContentConfigForm = true;
      this.isUpdateContentConfigForm = true;
    },
    newColorOrigin() {
      this.clearContentConfigForm();
      this.displayContentConfigForm = true;
      this.isUpdateContentConfigForm = false;
    },
    clearContentConfigForm() {
      this.contentConfigForm.origin = {};
      this.contentConfigForm.color = AppConstants.DEFAULT_CONTENT_CONFIG_COLOR;
    },
    updateRoute(item) {
      const index = this.form.platformWdmaRoute.findIndex(r => r.country.id == item.country.id);
      if (index >= 0) {
        this.form.platformWdmaRoute[index] = {
          routeName: item.routeName,
          country: item.country
        };
      } else {
        this.form.platformWdmaRoute.push({
          routeName: item.routeName,
          country: item.country
        });
      }
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_CONTENT);
    },
    onSubmit() {
      contentService
        .registerContent(this.form, new URLSearchParams())
        .then(() => {
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getContentDetails() {
      const params = new URLSearchParams();
      contentService
        .getContentDetails(this.dataID, params)
        .then((res) => {
          this.form._id = res._id;
          this.form.code = res.code;
          this.form.namePtBr = res.namePtBr;
          this.form.nameEnEu = res.nameEnEu;
          this.form.nameEsEs = res.nameEsEs;
          this.form.nameEsAr = res.nameEsAr;
          this.form.namePtPt = res.namePtPt;
          this.form.nameZhCn = res.nameZhCn;
          this.form.icon = res.icon;
          this.form.order = res.order;
          this.form.origin = res.origin;
          this.form.search_origin = res.search_origin;
          this.form.search_subject = res.search_subject;
          this.form.color_origin = res.color_origin.map(item => {
            item.origin.id = item.origin._id;
            return item;
          });
          this.form.active = res.active;
          this.form.isQuotes = res.isQuotes;
          this.form.isReport = res.isReport;
          this.form.displaySubmenu = res.displaySubmenu;
          this.form.displayInPublicArea = res.displayInPublicArea;
          this.form.enableInPublicArea = res.enableInPublicArea;
          this.form.chartEvent = res.chartEvent;
          this.form.platformWdmaRoute = res.platformWdmaRoute;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getChartEvents(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
      ]).then((res) => {
        this.origins = res[0];
        this.chartEvent = res[1];
        this.countries = res[2];
        if (this.isUpdate) {
          this.getContentDetails();
        }
      })
      .catch((err) => console.log(err));
    },
    loadSubjects() {
      this.subjects = [];
      const params = new URLSearchParams();
      params.append("origins", this.form.search_origin.map(item => item.id).join(','));
      dropdownService.getAllSubjects(params)
      .then(res => {
        this.subjects = res;
      })
      .catch((err) => {
          console.log(err);
        });
    }
  },
  components: {
    BButton, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm,
    BTabs, BTab, BCard, BListGroup, BListGroupItem, vSelect, ContentRegisterRoutes
  },
};
</script>

<style lang="scss">
.content-register .tab-content > .active {
  display: block;
}
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>